import styled from '@emotion/styled'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1400px;
`
